"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useReactionStyles = exports.reactionVars = exports.reactionCommon = void 0;
var _createUseStyles = _interopRequireDefault(require("../../themes/createUseStyles"));
var _commonProps = require("../../utils/vars/commonProps");
var _initVars = _interopRequireDefault(require("../../utils/vars/initVars"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @copyright
 * Copyright (c) 2025 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var reactionCommon = exports.reactionCommon = _commonProps.defaultCommonProps;
var reactionVars = exports.reactionVars = (0, _initVars.default)({
  applied: reactionCommon,
  variables: [{
    key: "reactionSize"
  }, {
    key: "reactionScale"
  }, {
    key: "reactionCursor"
  }, {
    key: "reactionFontSize"
  }]
});
var styles = function styles(theme) {
  return {
    "@global": {
      particle: {
        position: "fixed",
        top: 0,
        // eslint-disable-next-line @atg/css-rtl-support
        left: 0,
        opacity: 0,
        pointerEvents: "none"
      }
    },
    variables: reactionVars.styles,
    root: {
      whiteSpace: "nowrap",
      position: "relative",
      cursor: reactionVars.get("reactionCursor"),
      userSelect: "none",
      lineHeight: 1,
      display: "flex",
      alignItems: "center"
    },
    disabled: {
      pointerEvents: "none",
      filter: "grayscale(100%)",
      color: theme.colors.baseContrast050,
      "& svg": {
        fill: theme.colors.baseContrast030,
        borderColor: theme.colors.baseContrast030
      }
    },
    icon: {
      margin: theme.spacing.base / 2,
      fontSize: reactionVars.get("reactionFontSize"),
      lineHeight: 1,
      "& img": {
        width: reactionVars.get("reactionSize"),
        height: reactionVars.get("reactionSize")
      },
      "& svg": {
        fill: theme.colors.baseInvariant,
        width: reactionVars.get("reactionSize"),
        height: reactionVars.get("reactionSize"),
        transform: reactionVars.get("reactionScale")
      }
    },
    total: {
      color: theme.colors.baseInvariant,
      fontSize: reactionVars.get("reactionSize"),
      lineHeight: 1,
      margin: theme.spacing.base / 2
    },
    left: {
      flexDirection: "row"
    },
    right: {
      flexDirection: "row-reverse"
    },
    top: {
      flexDirection: "column-reverse"
    },
    bottom: {
      flexDirection: "column"
    }
  };
};
var useReactionStyles = exports.useReactionStyles = (0, _createUseStyles.default)(styles, {
  name: "Reaction"
});